import { digits, isInteger, isMoreFloat, isRequiredText, isRequiredWithObj, strMax, } from './utils';
export const validateDepartment = [
    isRequiredText('部署名を入力してください'),
    strMax(100, '部署名は100文字以内で入力してください'),
];
export const validatePosition = [isRequiredText('役職を選択してください')];
export const validatePositionOther = [
    isRequiredText('その他を入力してください'),
    strMax(50, 'その他は50文字以内で入力してください'),
];
export const validateOccupation = [isRequiredText('職種を選択してください')];
export const validateOccupationOther = [
    isRequiredText('その他を入力してください'),
    strMax(50, 'その他は50文字以内で入力してください'),
];
export const validateFreeOrganization = [
    strMax(200, '所属する会社・機関名は200文字以内で入力してください'),
];
export const validateOrganization = [isRequiredText('企業名を選択してください')];
export const validateOrganizationOther = [
    isRequiredText('その他を入力してください'),
    strMax(50, 'その他は50文字以内で入力してください'),
];
export const validateAddress1 = [
    strMax(50, '住所（市区町村）は50文字以内で入力してください'),
];
export const validateAddress2 = [
    strMax(50, '住所（丁目・番地）は50文字以内で入力してください'),
];
export const validateAddress3 = [
    strMax(50, '住所（建物名・部屋番号）は50文字以内で入力してください'),
];
export const validateRequiredAddress1 = [
    isRequiredText('住所（市区町村）を入力してください'),
    ...validateAddress1,
];
export const validateRequiredAddress2 = [
    isRequiredText('住所（丁目・番地）を入力してください'),
    ...validateAddress2,
];
/**
 * @deprecated 以降は src/utils/validate/common.ts のvalidatePhoneNumberを利用してください
 * @type {((function(*=): string)|(function(*): (*|string))|*)[]}
 */
export const validatePhoneNumber = [
    isRequiredText('電話番号を入力してください'),
    strMax(4, '桁が多すぎます。入力内容をご確認ください'),
    isInteger('半角数字で入力してください'),
];
export const validateZipCode1NoRequired = [
    isRequiredWithObj('郵便番号を入力してください', 'zipCode2'),
    digits(3, '3桁の値を入力してください'),
    isInteger('半角数字で入力してください'),
];
export const validateZipCode2NoRequired = [
    isRequiredWithObj('郵便番号を入力してください', 'zipCode1'),
    digits(4, '4桁の値を入力してください'),
    isInteger('半角数字で入力してください'),
];
export const validateZipCode1 = [
    isRequiredText('郵便番号を入力してください'),
    digits(3, '3桁の値を入力してください'),
    isInteger('半角数字で入力してください'),
];
export const validateZipCode2 = [
    isRequiredText('郵便番号を入力してください'),
    digits(4, '4桁の値を入力してください'),
    isInteger('半角数字で入力してください'),
];
export const validateMinimumFeePerHour = [
    isRequiredText('時間あたりの最低フィーを入力してください'),
    isMoreFloat(0, '0より大きい値を入力してください'),
];
export const validateMinimumFeePerDay = [
    isRequiredText('日にちあたりの最低フィーを入力してください'),
    isMoreFloat(0, '0より大きい値を入力してください'),
];
export const validateDesiredFeePerHour = [
    isRequiredText('時間あたりの希望フィーを入力してください'),
    isMoreFloat(0, '0より大きい値を入力してください'),
];
export const validateDesiredFeePerDay = [
    isRequiredText('日にちあたりの希望フィーを入力してください'),
    isMoreFloat(0, '0より大きい値を入力してください'),
];
export const validateMiddleTaskOther = [
    isRequiredText('その他を入力してください'),
    strMax(25, '25文字以内で入力してください'),
];
